<div class="category-cell-container">
  <div class="category-cell-gradient-bar">
    <span>{{ category }}</span>
  </div>
</div>
